import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsShow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowsShow"><Path d="M12.75 19.4395L14.4697 17.7197L15.5303 18.7803L12 22.3105L8.46973 18.7803L9.53027 17.7197L11.25 19.4395V14H12.75V19.4395Z" fill="currentColor"/><Path d="M8 9.5H3.5V14.5H8V16H2V8H8V9.5Z" fill="currentColor"/><Path d="M22 16H16V14.5H20.5V9.5H16V8H22V16Z" fill="currentColor"/><Path d="M15.5303 5.21973L14.4697 6.28027L12.75 4.56055V10H11.25V4.56055L9.53027 6.28027L8.46973 5.21973L12 1.68945L15.5303 5.21973Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowsShow;
